import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  header: {
    textAllign: 'center',
  },
}));

export const WizardStepTitle = ({ title, align = 'center' }) => {
  const classes = useStyles();

  return (
    <div className={classes.header}>
      <Typography variant="h3" align={align} style={{fontSize: '40px'}}>
        {title}
      </Typography>
    </div>
  );
};

export const WizardStepContainer = ({ title, children }) => (
  <div className="container wizard-step-content">
    {title && <div className="row">
      <div className="col-12">
        <WizardStepTitle title={title}/>
      </div>
    </div>}
    {children}
  </div>
);
